import countries from "i18n-iso-countries";
import enLocale from 'i18n-iso-countries/langs/en.json';
import moment from "moment-timezone";

countries.registerLocale(enLocale)

export const countryObj = countries.getNames("en", { select: "official" });
export const countryArray = Object.entries(countryObj).map(([key, value]) => {
    return {label:value, key:key}
}).filter(c => c.key);

export const getCountryName = (code) => {
    return countries.getName(code,'en')
}

export const eventStatus= {
    STATUS_ACTIVE: 10,
    STATUS_COMPLETED: 20,
    STATUS_PLANNED_REGISTRATION_CLOSED:25,
    STATUS_PLANNED: 30,
    STATUS_SCHEDULED: 40,
    STATUS_CANCELLED: 90,
}

export const eventStatusLabel = {
    10: 'Active',
    20: 'Completed',
    25: 'Planned',
    30: 'Planned',
    40: 'Scheduled',
    90: 'Cancelled',
}

export const eventStatusColor = {
    10: 'success',
    20: 'info',
    25: 'info',
    30: 'info',
    40: 'warning',
    90: 'error',
}

export const registrationStatus= {
    STATUS_OK : 0x1,
    STATUS_CANCELED : 0x4,
    STATUS_BANNED : 0x5,
    STATUS_SUBMITTED : 0x10,
    STATUS_QUALIFIED: 0x17,
    STATUS_QUALIFIED_RESERVE: 0x18,
    STATUS_PRELIMINARY : 0x19,
    STATUS_PENDING : 0x20,
    STATUS_REJECTED : 0x30,
    STATUS_APPROVED : 0x40,
    STATUS_RESUBMITTED : 0x50,
    STATUS_ON_PROBATION : 0x300,
    STATUS_WITHDRAWN : 0x401,
}

export const isViableRegistrationStatus = (status) =>{
    switch(status) {
        case registrationStatus.STATUS_OK:
        case registrationStatus.STATUS_SUBMITTED:
        case registrationStatus.STATUS_QUALIFIED:
        case registrationStatus.STATUS_QUALIFIED_RESERVE:
        case registrationStatus.STATUS_PRELIMINARY:
        case registrationStatus.STATUS_PENDING:
        case registrationStatus.STATUS_APPROVED:
            return true;
        default: return false;
    }
}

export const competitionRegistrationStatusLabel = {
    0x10: 'Applied',
    0x17: 'Qualified',
    0x18: 'Reserve',
    0x19: 'Pre-registered',
    0x20: 'Pending',
    0x30: 'Rejected',
    0x40: 'Registered',
    0x401: 'Withdrawn',
    0x01: 'OK',
    0x04: 'Canceled',
    0x05: 'Banned',
    0x50: 'Resubmitted',
}


export const competitionRegistrationStatusColor = {
    0x10: 'info',
    0x17: 'success',
    0x18: 'info',
    0x19: 'success',
    0x20: 'warning',
    0x30: 'error',
    0x40: 'success',
    0x401: 'error',
    0x01: 'warning',
    0x04: 'error',
    0x05: 'error',
    0x50: 'warning',
}


export const eventResourceCategory = {
    WAYPOINT_LIST: 0x11,
    AIRSPACE_FILE: 0x13,
    TASK_LIST: 0x17,
    SERIES_RULES: 0x21,
    LOCAL_PROCEDURES: 0x23,
    DOCUMENT: 0x31,
}

export const getRlPilot = (rlid, callback, errorCallback) => {
    const url =`https://www.crosscountry.aero/igcrl/rl/pilot/${rlid}`

    fetch(url, {
        method: "GET",
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            if (errorCallback) {
                errorCallback(error)
            }
            else {
                console.log('*** ERROR while fetching from ranking list')
                console.log(error)
            }
        })
}
export const searchRlPilotName = (txt, callback, errorCallback) => {
    const url =`https://pilots.azurewebsites.net/Pilot/GetPilots?auth=khuKs34it77&partialFirstOrLastName=${txt}`

    fetch(url, {
        method: "GET",
    })
        .then((response) => response.json())
        .then((data) => {
            callback(data)
        })
        .catch((error) => {
            if (errorCallback) {
                errorCallback(error)
            }
            else {
                console.log('*** ERROR while searching IGC ranking list for pilot name')
                console.log(error)
            }
        })
}

export const rankEventStatus = (status) => {
    switch (status) {
        case registrationStatus.STATUS_ACTIVE:
            return 1
        case registrationStatus.STATUS_COMPLETED:
            return 3
        case registrationStatus.STATUS_PLANNED_REGISTRATION_CLOSED:
        case registrationStatus.STATUS_PLANNED:
            return 2
        case registrationStatus.STATUS_SCHEDULED:
            return 4
        case registrationStatus.STATUS_CANCELLED:
            return 5
    }
}

export const isEventScheduledToday = (evt) => {
    return moment().isBetween(moment(evt.firstDate), moment(evt.lastDate),'day','[]')
}

export const findClosestDate = (fromDate, dateArray) => {
    let nearestDate;

    dateArray.forEach(date => {
        let diff = moment(date).diff(moment(fromDate), 'days');
        if (diff > 0) {
            if (nearestDate) {
                if (moment(date).diff(moment(nearestDate), 'days') < 0) {
                    nearestDate = date;
                }
            } else {
                nearestDate = date;
            }
        }
    })

    return nearestDate
}

export const findMostRelevantEvent = (events) => {
    if (events.length === 1) return events[0]
    if (events.length === 0) return undefined

    const sortedEvents = events.toSorted((a,b)=>{
        const aRankedStatus = rankEventStatus(a.status)
        const bRankedStatus = rankEventStatus(b.status)
        if (aRankedStatus !== bRankedStatus) return aRankedStatus - bRankedStatus

        const aIsToday = isEventScheduledToday(a)
        const bIsToday = isEventScheduledToday(a)

        if (aIsToday || bIsToday) return aIsToday === bIsToday ? 0 : aIsToday ? -1 : 1

        const aDiff = moment(a.firstDate).diff(moment(),'day')
        const bDiff = moment(b.firstDate).diff(moment(),'day')

        if (aDiff > 0 && bDiff > 0) {
            return aDiff - bDiff
        }
        else if (aDiff < 0 && bDiff < 0) {
            return bDiff - aDiff
        }
        else {
            return aDiff >0 ? -1 : 1
        }
    })

    return sortedEvents[0]
}